import StatisticTooltip from './StatisticTooltip';

export default StatisticTooltip;
